import { render, staticRenderFns } from "./goodssku.vue?vue&type=template&id=530435a6&"
import script from "./goodssku.vue?vue&type=script&lang=js&"
export * from "./goodssku.vue?vue&type=script&lang=js&"
import style0 from "./goodssku.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports